/** Branch context for data migration — matches employee list scoping. */
export const getMigrationBranchId = () => {
    try {
        const active = sessionStorage.getItem("active_branch_id");
        if (active && active !== "all" && active !== "null") return active;
        const home = sessionStorage.getItem("branch_id");
        if (home && home !== "null" && home !== "") return home;
    } catch {
        /* ignore */
    }
    return null;
};

export const migrationBranchFilter = () => {
    const id = getMigrationBranchId();
    return id ? { branch: id } : {};
};

export const migrationBranchLabel = () => {
    try {
        const activeName = sessionStorage.getItem("active_branch_name");
        if (activeName) return activeName;
        return sessionStorage.getItem("branch_name") || "";
    } catch {
        return "";
    }
};
